import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';
import { Link } from 'react-router';
import Menu from '../Menu';
import Header from '../Header';
import SidebarWrapper from '../SidebarWrapper';
import RepVisitsPendingCounter from '../RepVisitsPendingCounter';
import FeatureEnabled from '../FeatureEnabled';
import { REPVISITS_RSVP_COUNTER, REP_VISITS_SUBSCRIPTION } from '../../containers/Authorization/constants';
import './styles.css';

export const messages = defineMessages({
  requests: {
    id: 'repvisits.notifications.menu.request',
    defaultMessage: 'Requests',
  },
  activity: {
    id: 'repvisits.notifications.menu.activity',
    defaultMessage: 'Activity',
  },
  hsavailable: {
    id: 'repvisits.notifications.menu.hsavailable',
    defaultMessage: 'High Schools Now Available',
  },
  allAppointments: {
    id: 'repvisits.notifications.appointmentTypes.all',
    defaultMessage: 'All Appointment Types',
  },
  repVisits: {
    id: 'repvisits.notifications.appointmentTypes.rep-visits',
    defaultMessage: 'Rep Visits',
  },
  collegeFairs: {
    id: 'repvisits.notifications.appointmentTypes.college-fairs',
    defaultMessage: 'College Fairs',
  },
  allTime: {
    id: 'repvisits.notifications.appointmentTime.all',
    defaultMessage: 'All Time',
  },
  thisWeek: {
    id: 'repvisits.notifications.appointmentTime.this-week',
    defaultMessage: 'This Week',
  },
  lastMonth: {
    id: 'repvisits.notifications.appointmentTime.last-month',
    defaultMessage: 'Last 30 Days',
  },
  notifications: {
    id: 'repvisits.notifications',
    defaultMessage: 'Notifications',
  },
  closeSidebar: {
    id: 'repvisits.closeSidebar',
    defaultMessage: 'Close Sidebar',
  },
});

class RepVisitsNotificationsFrame extends React.PureComponent {
  static propTypes = {
    viewer: PropTypes.object,
    route: PropTypes.object,
    children: PropTypes.node,
    router: PropTypes.shape({
      location: PropTypes.object.isRequired,
    }).isRequired,
  };

  state = {
    sidebarComponent: null,
    sidebarVisible: false,
  };

  displaySidebarComponent = (component) => {
    /* istanbul ignore else */
    if (component) {
      this.setState({
        sidebarVisible: true,
        sidebarComponent: component,
      });
    }
  };

  closeSidebar = () => {
    /* istanbul ignore else */
    if (this.state.sidebarVisible) {
      this.setState({ sidebarVisible: false });
    }
  };

  render() {
    const { route, children, viewer: { heAccount: { activeSubscriptions } }, router } = this.props;
    const { sidebarVisible, sidebarComponent } = this.state;
    return (
      <SidebarWrapper>
        <SidebarWrapper.Content dimmed={sidebarVisible} onClick={this.closeSidebar}>
          <div styleName="top-container">
            <Header id="page-heading" as="h1" styleName="container-title"><FormattedMessage {...messages.notifications} /></Header>
            <div styleName="container">
              <section aria-labelledby="right-side-heading">
                <nav aria-label="RepVisits Side Menu">
                  <Menu as="ul" vertical className="third">
                    {route && route.childRoutes && route.childRoutes.map(({ path }) => (
                      (path !== 'hsavailable' || (path === 'hsavailable' && activeSubscriptions.includes(REP_VISITS_SUBSCRIPTION))) && (
                        <Menu.Item name={path} key={path} as="li">
                          <Link
                            to={`/rep-visits/notifications/${path}`}
                            className="menu-link"
                            activeClassName="active"
                            aria-label={messages[path].defaultMessage}
                            aria-current={router.location.pathname.includes(path) ? 'true' : 'false'}
                          >
                            <div styleName="menu-item-content">
                              <FormattedMessage {...messages[path]} />
                              {path === 'requests' && (
                                <FeatureEnabled allOf={[REPVISITS_RSVP_COUNTER]}>
                                  <RepVisitsPendingCounter />
                                </FeatureEnabled>
                              )}
                            </div>
                          </Link>
                        </Menu.Item>
                      )))}
                  </Menu>
                </nav>
              </section>
              <section styleName="content" aria-labelledby="menu-options" id="menu-options">
                {children && React.cloneElement(
                  children, { displaySidebarComponent: this.displaySidebarComponent, closeSidebar: this.closeSidebar },
                )}
              </section>
            </div>
          </div>
        </SidebarWrapper.Content>
        {sidebarComponent && React.cloneElement(sidebarComponent, { visible: sidebarVisible, onClose: this.closeSidebar })}
      </SidebarWrapper>
    );
  }
}

export default RepVisitsNotificationsFrame;
